import { CircleAlert, Info, TriangleAlert } from 'lucide-react';
import { useState } from 'react';
import type { PlanIssue } from '@tempo/core';

const ORDER = { error: 0, warn: 1, info: 2 };

export function IssuesPanel({ issues, date, compact }: { issues: PlanIssue[]; date?: string; compact?: boolean }) {
  const [open, setOpen] = useState(false);
  const relevant = issues
    .filter((i) => !date || i.date === date || (i.date === null && i.severity !== 'info'))
    .sort((a, b) => ORDER[a.severity] - ORDER[b.severity]);
  if (!relevant.length) return null;
  const important = relevant.filter((i) => i.severity !== 'info');
  const shown = open || !compact ? relevant : important.slice(0, 3);
  return (
    <div className="stack tight">
      {shown.map((i) => (
        <div key={i.id} className={`issue ${i.severity}`}>
          {i.severity === 'error' ? <CircleAlert size={16} /> : i.severity === 'warn' ? <TriangleAlert size={16} /> : <Info size={16} />}
          <span>{i.message}</span>
        </div>
      ))}
      {compact && relevant.length > shown.length && (
        <button className="btn ghost sm" style={{ alignSelf: 'flex-start' }} onClick={() => setOpen(true)}>
          Show {relevant.length - shown.length} more note{relevant.length - shown.length === 1 ? '' : 's'}
        </button>
      )}
    </div>
  );
}
